import styled from 'styled-components';

import { border1, green } from 'utils/style/colors';

import Icon from 'components/Icon';
import HoverIcon from 'components/HoverIcon';

interface ISignatureContainerProps {
  loading: boolean;
}

export const Remove = styled(HoverIcon)`
  position: absolute;
  align-self: normal;
  right: 0;
  //display: none;
`;

export const UploadSignatureContainer = styled('div')<ISignatureContainerProps>`
  border-radius: 10px;
  border: ${border1};
  background-color: white;
  width: 150px;
  height: 150px;
  transition: all 0.3s ease;
  :hover ${Remove} {
    display: block;
  }
  ${({ loading }) =>
    loading &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const ThumbImage = styled('img')`
  border-radius: 10px;
  width: 100%;
  height: 100%;
`;

export const SignatureThumbContainer = styled('div')`
  height: 100%;
  display: inline-flex;
  position: relative;
`;

export const Save = styled('span')`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${green};
  color: white;
  font-size: 0.7em;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  cursor: pointer;
`;

export const SignatureText = styled(Save)`
  background-color: gray;
  font-size: 1em;
`;

export const StyledDropzone: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  borderRadius: '6px',
  backgroundColor: 'var(--exact-white)',
  cursor: 'pointer',
  width: '100%',
  height: '100%',
};

export const CustomIcon = styled(Icon)`
  display: block;
  padding-top: 0.5rem;
`;
